// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --googleFont2: "Lustria", serif;
    --googleFont: "Fira Sans Condensed", serif;

    /*Color scheme*/
    --DarkBlue: #0b132b;
    --GrayBlue: #1c2541;
    --LiterGrayBlue: #253155;
    --Gray: #3a506b;
    --HighlightBlue: #5bc0be;
}

/* sideScrollbar */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-track {
    background: var(--GrayBlue);
}

::-webkit-scrollbar-thumb {
    background: var(--DarkBlue);
}

body {
    margin: 0;
    font-family: var(--googleFont);
    font-style: italic;
    font-weight: 900;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--middelColor);
    scroll-behavior: smooth;
    overflow: hidden;
}

h1,
h2,
h3,
a,
h4,
h5,
p {
    color: white;
}

code {
    font-family:
        source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

.globalContentDiv {
    padding: 20px 10px;
    max-width: var(--maxMiddelContainerWidth);
    margin-left: auto;
    margin-right: auto;
    animation: fadeInGlobal 1s;
}

.scrollableContainer {
    overflow-y: auto !important;
    padding-bottom: 1em;
    height: calc(100vh - 45px);
    max-height: 100%;
    box-sizing: border-box;
    margin-top: 0px;
}

@media only screen and (max-width: 768px) {
    .globalContentDiv {
        padding: 20px 4px;
        padding-right: 6px;
        margin-left: auto;
        margin-right: auto;
    }
}

@media screen and (max-width: 768px) {
    .scrollableContainer {
        padding-left: 0.5em;
        padding-right: 0.5em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/root.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,0CAA0C;;IAE1C,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,wBAAwB;AAC5B;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;IAClC,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;;;;;;IAOI,YAAY;AAChB;;AAEA;IACI;0EACsE;AAC1E;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ","sourcesContent":[":root {\n    --googleFont2: \"Lustria\", serif;\n    --googleFont: \"Fira Sans Condensed\", serif;\n\n    /*Color scheme*/\n    --DarkBlue: #0b132b;\n    --GrayBlue: #1c2541;\n    --LiterGrayBlue: #253155;\n    --Gray: #3a506b;\n    --HighlightBlue: #5bc0be;\n}\n\n/* sideScrollbar */\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n}\n\n::-webkit-scrollbar-track {\n    background: var(--GrayBlue);\n}\n\n::-webkit-scrollbar-thumb {\n    background: var(--DarkBlue);\n}\n\nbody {\n    margin: 0;\n    font-family: var(--googleFont);\n    font-style: italic;\n    font-weight: 900;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background: var(--middelColor);\n    scroll-behavior: smooth;\n    overflow: hidden;\n}\n\nh1,\nh2,\nh3,\na,\nh4,\nh5,\np {\n    color: white;\n}\n\ncode {\n    font-family:\n        source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n.globalContentDiv {\n    padding: 20px 10px;\n    max-width: var(--maxMiddelContainerWidth);\n    margin-left: auto;\n    margin-right: auto;\n    animation: fadeInGlobal 1s;\n}\n\n.scrollableContainer {\n    overflow-y: auto !important;\n    padding-bottom: 1em;\n    height: calc(100vh - 45px);\n    max-height: 100%;\n    box-sizing: border-box;\n    margin-top: 0px;\n}\n\n@media only screen and (max-width: 768px) {\n    .globalContentDiv {\n        padding: 20px 4px;\n        padding-right: 6px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .scrollableContainer {\n        padding-left: 0.5em;\n        padding-right: 0.5em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
